import { render, staticRenderFns } from "./ModuleCoinbaseStaking.vue?vue&type=template&id=6915b692&scoped=true"
import script from "./ModuleCoinbaseStaking.vue?vue&type=script&lang=js"
export * from "./ModuleCoinbaseStaking.vue?vue&type=script&lang=js"
import style0 from "./ModuleCoinbaseStaking.vue?vue&type=style&index=0&id=6915b692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915b692",
  null
  
)

export default component.exports